// OneDrive:CoverageThreshold(75)

export * from '@ms/telemetry-manager/lib/Manager';
export { Manager as default } from '@ms/telemetry-manager/lib/Manager';
